export default __webpack_public_path__ + "locales/pt-BR/ConvertDialog.json?hash=9c64eb5d1b749c6ce2400388dea40870";